<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent != null && localService.languageContent.menu_popup != undefined">
  <app-popup-header title="{{localService.languageContent.menu_popup.header}}"></app-popup-header>
  <div class="modal-body modal-body-no-flexible-height" *ngIf="wrapper != undefined" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-md-12">
        <ngx-select [(ngModel)]="wrapper.content.v1" [optionValueField]="'key'" [optionTextField]="'value'" [items]="getAvailableParentMenus()" placeholder="{{localService.languageContent.menu_popup.select_parent_menu}}" [allowClear]="true" [noAutoComplete]="true" (select)="onLoadNextOrder()" (remove)="onLoadNextOrder()">
        </ngx-select>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <span>{{localService.languageContent.menu_popup.order_nbr}}</span>
      </div>
      <div class="col-3">
        <span>:&nbsp;</span>
        <input autocomplete="off" type="number" class="number en" (keypress)="localService.isNumberOnly($event)" style="width:50px;" [(ngModel)]="wrapper.content.v2" />
      </div>
      <div class="col-5">
        <label style="font-weight:normal;">
          <input type="checkbox" [(ngModel)]="isPublic">
          <span style="font-size:16px;color:darkslategrey">&nbsp;{{localService.languageContent.menu_popup.is_public}}</span>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <span>{{localService.languageContent.menu_popup.page_key}}</span>
      </div>
      <div class="col-3">
        <span>:&nbsp;</span>
        <input autocomplete="off" type="number" class="number en" (keypress)="localService.isNumberOnly($event)" style="width:50px;" [(ngModel)]="wrapper.content.v6" />
      </div>
      <div class="col-5">
        <label style="font-weight:normal;">
          <input type="checkbox" [(ngModel)]="isInternal">
          <span style="font-size:16px;color:darkslategrey">&nbsp;{{localService.languageContent.menu_popup.is_internal}}</span>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <span>{{localService.languageContent.menu_popup.path}}</span>
      </div>
      <div class="col-9">
        :&nbsp;<input autocomplete="off" type="text" class="en" [(ngModel)]="wrapper.content.v5" />
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <span>{{localService.languageContent.menu_popup.icon}}</span>
      </div>
      <div class="col-9">
        :&nbsp;<input autocomplete="off" type="text" class="en" [(ngModel)]="wrapper.content.v3" />
      </div>
    </div>
    <app-language-container [MaxLength]="30" [id]="elementIds.name" [(languageContents)]="wrapper.languageContents" (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)" [IsShowAllLanguages]="true"></app-language-container>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="message != ''">
    <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
